import { useState } from "react";

const ServicePopup = ({ isOpen, serviceId, serviceDetails, onClose, onRegister }) => {
  const [isLoading, setIsLoading] = useState(false);
  if (!isOpen || serviceId === null) return null;

  const handleOverlayClick = () => {
    if (!isLoading) onClose();
  };

  const handlePopupClick = (e) => {
    e.stopPropagation(); 
  };

  const handleRegisterClick = () => {
    setIsLoading(true);
    setTimeout(() => {
      onRegister();
      setIsLoading(false);
    }, 800);
  };

  return (
    <div
      onClick={handleOverlayClick}
      className="fixed inset-0 z-[300] flex items-center justify-center px-4 bg-gray-900/60 backdrop-blur-md"
    >
      <div
        onClick={handlePopupClick}
        className="relative bg-white w-full max-w-md rounded-[1rem] p-6 shadow-2xl border border-amber-100 transform transition-all animate-in fade-in zoom-in duration-300"
      >
        

        <div className="mt-2">
         <div className="flex justify-center">
           <h2 className="text-lg md:text-2xl font-semibold text-gray-900 mb-4">
            {serviceDetails[serviceId]?.title}
          </h2>

          <button
            onClick={onClose}
            disabled={isLoading}
            className={`absolute right-4 text-gray-400 hover:text-gray-600 ${isLoading ? 'cursor-not-allowed opacity-50' : ''}`}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
         </div>

          <div className="text-gray-600 font-medium leading-relaxed">
            {serviceDetails[serviceId]?.content}
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={handleRegisterClick}
              disabled={isLoading}
              className={`min-w-[120px] flex items-center justify-center gap-2 bg-gradient-to-br from-amber-600 to-orange-600 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 ${isLoading ? 'opacity-70 cursor-not-allowed' : 'hover:from-amber-700 hover:to-orange-700'}`}
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Loading...</span>
                </>
              ) : (
                "Register"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePopup;